/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Filter_LineInputs */

const fr_map_filter_line = /** @type {(inputs: Map_Filter_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer par ligne`)
};

const en_map_filter_line = /** @type {(inputs: Map_Filter_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by line`)
};

/**
* | output |
* | --- |
* | "Filter by line" |
*
* @param {Map_Filter_LineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_filter_line = /** @type {((inputs?: Map_Filter_LineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Filter_LineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_filter_line(inputs)
	return en_map_filter_line(inputs)
});